import { render } from "./RoomsDetails.vue?vue&type=template&id=13bf927a"
import script from "./RoomsDetails.vue?vue&type=script&lang=js"
export * from "./RoomsDetails.vue?vue&type=script&lang=js"

import "./RoomsDetails.vue?vue&type=style&index=0&id=13bf927a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__